import { render, staticRenderFns } from "./SubMenus.vue?vue&type=template&id=70eb87ba"
import script from "./SubMenus.vue?vue&type=script&lang=js"
export * from "./SubMenus.vue?vue&type=script&lang=js"
import style0 from "./SubMenus.vue?vue&type=style&index=0&id=70eb87ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports